<div class="so-file-list">
  @if (hasItems()) {
    @for (item of items(); track trackByItem($index, item)) {
      <div class="so-file-list__item">
        @if (showIcons()) {
          @if (iconList()?.length) {
            <div class="so-file-list__icon-list">
              @for (icon of iconList(); track $index) {
                <so-svg-icon-ui
                  [name]="icon.name"
                  [size]="icon.size ?? 24"
                  [color]="icon.color ?? getColorForFile(getItemName(item))">
                </so-svg-icon-ui>
              }
            </div>
          } @else {
            <so-svg-icon-ui
              [name]="getIconForFile(getItemName(item))"
              [size]="24"
              [color]="getColorForFile(getItemName(item))">
            </so-svg-icon-ui>
          }
        }
        <p class="so-file-list__name text-truncate" [title]="getItemName(item)">
          {{ getItemName(item) }}
        </p>
        <div class="so-file-list__actions">
          @if (showDeleteButton()) {
            <button
              type="button"
              class="so-file-list__action so-file-list__action--delete"
              (click)="onDelete(item, $index)">
              <so-svg-icon-ui
                [name]="deleteIconName()"
                [size]="20"
                [color]="'var(--so-danger-color, #dc3545)'">
              </so-svg-icon-ui>
            </button>
          }
          @if (showOpenButton()) {
            <button
              type="button"
              class="so-file-list__action so-file-list__action--open"
              (click)="onOpen(item, $index)">
              <so-svg-icon-ui
                [name]="openIconName()"
                [size]="20"
                [color]="'var(--so-primary-color, #007bff)'">
              </so-svg-icon-ui>
            </button>
          }
        </div>
      </div>
    }
  }
</div>
